export const ADMOB_NETWORK_SOURCE_ID = '5450213213286189855';

/** Legacy formats still listed on adapters but no longer creatable in Console. */
const LEGACY_FORMATS = new Set([
    'BANNER_INTERSTITIAL',
    'BANNER_AND_INTERSTITIAL',
]);

const FORMAT_ZH: Record<string, string> = {
    BANNER: '横幅',
    INTERSTITIAL: '插页',
    REWARDED: '激励',
    REWARDED_INTERSTITIAL: '插页式激励',
    NATIVE: '原生',
    APP_OPEN: '开屏',
};

export function collectFormatsFromAdapters(
    adapters: Array<{platform?: string; formats?: string[]}> | null | undefined,
    platform: string,
): string[] {
    const want = String(platform || '').toUpperCase();
    const set = new Set<string>();
    for (const adapter of adapters || []) {
        if (!adapter || typeof adapter !== 'object') continue;
        const p = String(adapter.platform || '').toUpperCase();
        if (want && p && p !== want) continue;
        for (const f of adapter.formats || []) {
            const fmt = String(f || '').toUpperCase().trim();
            if (!fmt || LEGACY_FORMATS.has(fmt)) continue;
            set.add(fmt);
        }
    }
    return [...set].sort();
}

export function formatOptionLabel(format: string): string {
    const fmt = String(format || '').toUpperCase().trim();
    if (!fmt) return '';
    const zh = FORMAT_ZH[fmt];
    return zh ? `${zh} ${fmt}` : fmt;
}

export function pickDefaultFormat(formats: string[], current?: string): string {
    const list = (formats || []).map((f) => String(f || '').toUpperCase()).filter(Boolean);
    const cur = String(current || '').toUpperCase();
    if (cur && list.includes(cur)) return cur;
    if (list.includes('BANNER')) return 'BANNER';
    return list[0] || '';
}
